import { render, staticRenderFns } from "./exportacion.vue?vue&type=template&id=0c88f366&scoped=true&lang=html"
import script from "./exportacion.vue?vue&type=script&lang=js"
export * from "./exportacion.vue?vue&type=script&lang=js"
import style0 from "./exportacion.vue?vue&type=style&index=0&id=0c88f366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88f366",
  null
  
)

export default component.exports